import React from "react";
import "../assets/css/AnimatedTextSection.css"; // Import the CSS

const AnimatedTextSection = () => {
  return (
    <section className="products-animated-section text-center py-5">
      <div className="container">
        <h2 className="products-heading">
          Products&nbsp;
          <span className="text-rotate">
            <span className="inner-text">Designed by science</span>
            <span className="inner-text">Inspired by you</span>
          </span>
        </h2>
      </div>
    </section>
  );
};

export default AnimatedTextSection;
